import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const packagePickerTranslationsExtension = ModuleExtensions.translationsExtension(async locale => {
  const packageResources = await import(`@wix/premium-purchase-plan-translations/src/assets/locale/messages_${locale}.json`);
  return {
    ...packageResources
  };
}, {
  namespace: 'premium-purchase-plan-translations'
});
//# sourceMappingURL=package-picker-translations.extension.js.map